import { getListRechargeByType, hiddenRecharge, rechargeAll, rechargeCreate, resentRecharge, statusScheduledRecharge } from '../../routes/api/paths';
import { handleResponse, requestOptions } from '../HandlerService';

export const RechargeByTypeService = async (type) => {
  const options = requestOptions('GET', {});
  return fetch(getListRechargeByType + '?type=' + type, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const RechargeCreateService = async (data) => {
  const parsedData = {
    ...data,
    contacts: data?.contacts?.map(contact => ({
      ...contact,
      phone: contact.phone && !contact.phone.startsWith('+53')
        ? `+53${contact.phone}`
        : contact.phone,
    })),
  };
  const options = requestOptions('POST', {
    ...parsedData,
    token: undefined
  }, data?.token);
  return fetch(rechargeCreate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const RechargeAllService = async (data) => {
  const { page, since, until, status, search, orderBy, orderField } = data;
  const options = requestOptions('GET', {}, data?.token);
  return fetch(`${rechargeAll}?page=${page || '1'}${since ? `&since=${since}` : ''}${until ? `&until=${until}` : ''}${status ? `&status=${status}` : ''}${search ? `&search=${search}` : ''}&orderBy=${orderBy || 'desc'}&orderField=${orderField || 'id'}`
  , options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const ResentRechargeService = async (data) => {
  const { ids, token } = data;
  const options = requestOptions('POST', {id: ids}, token);
  return fetch(resentRecharge, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const CheckStatusRechargeFlowService = async (token) => {
  const options = requestOptions('GET', {}, token);
  return fetch(statusScheduledRecharge, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const SetStatusRechargeFlowService = async (data) => {
  const { status, token } = data;
  const options = requestOptions('GET', {}, token);
  return fetch(statusScheduledRecharge + '/' + status, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const HiddenHistory = async (data) => {
  const { token } = data;
  const options = requestOptions('GET', {}, token);
  return fetch(hiddenRecharge, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}